<template>
  <custom-crud-list v-bind="listConfiguration">
    <template #cell-createdAt="{ item }">
      <span>{{ translateDate(item.createdAt, "dateWithTime") }}</span>
    </template>

    <template #cell-amount="{ item }">
      <span class="no-word-break">
        {{
          translateNumber(item.amount, "currency", {
            currency: item.AuctionProductType.Product.currency,
          })
        }}
      </span>
    </template>
    <template #cell-productName="{ item }">
      <span>
        {{ item.AuctionProductType.Product.name }}
      </span>
    </template>
    <template #cell-VendorId="{ item }">
      <span v-if="item.AuctionProductType.Product?.Vendor">
        {{ item.AuctionProductType.Product?.Vendor?.name }}
      </span>
      <span v-else> - </span>
    </template>

    <template #cell-isWinning="{ item }">
      <span v-if="item.AuctionProductType?.AuctionBids[0]">
        <span v-if="item.AuctionProductType?.AuctionBids[0].amount === item.amount">
          {{ t("core.yes") }}
        </span>
        <span v-else>
          {{ t("core.no") }}
        </span>
      </span>
      <span v-else> - </span>
    </template>
    <template #cell-OwnerId="{ item }">
      <span>
        {{ item?.Owner?.fullName }}
      </span>
    </template>
  </custom-crud-list>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import CustomCrudList from "@/client/components/crud/customV1/List.vue";

export default {
  name: "Bids",
  components: { CustomCrudList },
  props: {
    overrideListConfiguration: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  data: function () {
    return {
      listConfiguration: {
        subject: "auctionBid",
        listSrc: "justopp/bid",
        initialOrdering: { key: "createdAt", direction: "desc" },
        showIdField: true, // bool deafult true
        sortable: false, //bool, default false
        publishable: false, //bool, default false
        enableMassActions: false,
        //  createRoutePrefix: "admin-",
        // deleteRoutePrefix: "ecommerce/",
        additionalListData: {
          simplified: false,
          translate: false,
        },
        noItemsFoundText: "justopp.bids.noBids",
        fields: {
          createdFrom: {
            listable: false,
            filterable: {
              name: "createdFrom",
              type: "DatePicker",
              placeholder: "justopp.bid.fields.createdFrom",
            },
            type: "DatePicker",
            label: "justopp.bid.fields.createdFrom",
          },
          createdBefore: {
            listable: false,
            filterable: {
              name: "createdBefore",
              type: "DatePicker",
              placeholder: "justopp.bid.fields.createdBefore",
            },
            label: "justopp.bid.fields.createdBefore",
          },

          // these are the table columns
          createdAt: {
            itemKey: "createdAt",
            label: "justopp.bid.fields.createdAt",
            filterable: false,
          },
          amount: {
            name: "amount",
            label: "justopp.bid.fields.amount",
            orderable: false,
          },
          productName: {
            name: "productName",
            label: "justopp.bid.fields.productName",
            orderable: false,
            filterable: {
              name: "productName",
              type: "text",
              placeholder: "justopp.bid.fields.productName",
            },
          },
          isWinning: {
            label: "justopp.bid.fields.isWinning",
            orderable: false,
          },
        },
        actions: false,
        ...this.overrideListConfiguration,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.no-word-break {
  word-break: normal;
}
</style>
